<template>
  <div class="form__group--border py-16 pb-32">
    <div aria-hidden="true" class="form__label pb-16">Set the rates for the services you provide</div>
    <ul>
      <li v-for="serviceRate in serviceRates" :key="serviceRate.service">
        <ServiceRatesInput
          ref="childComponents"
          :serviceRate="serviceRate"
          @update:modelValue="updateRate"
          @serviceSelected="selectService"
        />
      </li>
    </ul>
    <HelperText v-if="!formStatuses.serviceRates" class="!-mt-16" :status="helperStatus.Error" :text="helperText" />
  </div>
</template>

<script lang="ts">
import { mapGetters } from 'vuex';
import helperStatus from '@/helpers/status';
import HelperText from '@/components/helper_text/HelperText.vue';
import ServiceRatesInput from './ServiceRatesInput.vue';
import focusOnElement from '@/helpers/focusHelper';

export default {
  name: 'ServiceRates',
  components: {
    ServiceRatesInput,
    HelperText,
  },
  data(): {
    helperStatus;
    formStatuses: {
      serviceRates: helperStatus;
    };
    errors: string[][];
  } {
    return {
      helperStatus,
      formStatuses: {
        serviceRates: helperStatus.Neutral,
      },
      errors: [],
    };
  },
  computed: {
    ...mapGetters(['selectedServiceRates']),
    serviceRates(): any {
      return this.$store.getters.getFormField('serviceRates');
    },
    helperText(): string {
      return this.formStatuses.serviceRates === helperStatus.Error ? 'At least one service is required' : '';
    },
  },
  methods: {
    selectService(payload) {
      this.resetErrorState('serviceRates');
      this.$store.dispatch('selectService', payload);
    },
    updateRate(rateChange) {
      this.resetErrorState('serviceRates');
      this.$store.dispatch('updateServiceRate', rateChange);
    },
    validate() {
      return this.validateService() && this.validateRate();
    },
    validateRate() {
      const errors: string[][] = [];
      (this.$refs.childComponents as any)?.forEach((childComponent) => {
        if (!childComponent.validate()) {
          const formFieldWithError = Object.keys(childComponent.formStatuses) as string[];
          errors.push(formFieldWithError);
        }
      });

      return errors.length === 0;
    },
    validateService() {
      if (this.selectedServiceRates.length === 0) {
        this.triggerErrorState('serviceRates');
      }

      return this.formStatuses.serviceRates;
    },
    triggerErrorState(fieldName) {
      this.formStatuses[fieldName] = helperStatus.Error;
    },
    resetErrorState(fieldName) {
      this.formStatuses[fieldName] = helperStatus.Neutral;
    },
    focusElement() {
      // send focus to first checkbox if none are selected
      // otherwise send focus to first empty rate text field under selected checkbox
      if (this.selectedServiceRates.length === 0) {
        focusOnElement(this.$refs.childComponents?.[0].$el.querySelector('input.checkbox'));
      } else {
        const emptyRateFields = (this.$refs.childComponents as any)?.filter(
          (component) => component.serviceRate.selected === true && component.serviceRate.rate === ''
        );
        focusOnElement(emptyRateFields?.[0].$el.querySelector('input.text-field-input'));
      }
    },
  },
};
</script>
